import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { DEVICE_REQUEST_ID_LIST } from './device-constant';

class DeviceServiceClass {
  postDeviceList = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/instant-login/inquiry',
      data: null,
      id: DEVICE_REQUEST_ID_LIST.POST_DEVICE_LIST
    });
  }

  postForceLogout = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/instant-login/force-logout',
      data: params.data,
      id: DEVICE_REQUEST_ID_LIST.POST_FORCE_LOGOUT
    });
  }
}

export const DeviceService = new DeviceServiceClass();
